import _ from 'lodash'
import Wizard from 'scoreboard/components/wizard'
import ConnectionLabelAndOwners from './connection-label-and-owners'
import i18n from 'scoreboard/components/i18n'
import DbConnectionStep1 from './db-connection-step1'
import enums from 'scoreboard/components/enums'

var DbConnectionWizard = Wizard.extend({

	/**
	 * Wizard for creating database import connections (#13318 and #13932)
	 *
	 * @constructs
	 *
	 * @param {Object} options
	 *
	 * @params {Connection} options.model
	 */
	initialize: function(options = {}) {
		var views = [ DbConnectionStep1, ConnectionLabelAndOwners ]
		let key = options.model.id ? 'common.edit2' : 'common.add2'
		let product = _.get(options.model.attributes, 'product', 'mysql')
		let dbType = i18n.get('admin.importConnections.db.type', enums.databaseProduct[product])
		let title = i18n.get(key, dbType)
		var opts = _.extend({ views, title }, options)
		Wizard.prototype.initialize.call(this, opts)
	}

})

export default DbConnectionWizard

DbConnectionWizard.__filename__ = 'admin/connections/db-connection-wizard.js'
